module.exports = __webpack_public_path__ + "img/1.15bc4461.png";